"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { chakra } from "@chakra-ui/react";
import { forwardRef } from "react";
import { ShortLogo } from "./logo";
/** The mark sits at nine sixteenths of the circle, as drawn for the registered-creator badge. */
const MARK_RATIO = 9 / 16;
/**
 * The round Fluenceur mark: the logo, white by default, centred in a filled
 * circle. Purely visual unless the caller names it (role, aria-label); the
 * glyph itself is always hidden from assistive technology. Forwards its ref so
 * it can be a tooltip trigger.
 */
export const CircleLogo = forwardRef(function CircleLogo({ size, markColor = "white", ...props }, ref) {
    return (_jsx(chakra.span, { ref: ref, display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0, boxSize: `${size}px`, borderRadius: "full", ...props, children: _jsx(ShortLogo, { height: `${Math.round(size * MARK_RATIO * 10) / 10}px`, color: markColor, "aria-hidden": true }) }));
});
